import React from "react";
import './Contacts.css'


class Contacts extends React.Component {
    render() {
        return (
            <div className="main">
                    <div className="contacts_lastpage">
                        <div className='contacts_lastpage-tel'>
                            <div className='contacts_lastpage-tel-name cont_padd'>Гаряча лінія</div>
                            <div className='contacts_lastpage-tel-text txt-padd'>
                                <h2>0 800 505 240</h2>
                                <p>У разі, якщо Ви не додзвонилися до оператора і всі лінії були зайняті або Ви телефонуєте в неробочий день та час, – залиште Ваш номер телефону на автовідповідач і ми Вам зателефонуємо</p>
                            </div>
                        </div>

                        <div className='contacts_lastpage-additional'>
                            <div className='contacts_lastpage-additional-name cont_padd'>Контактна інформація</div>
                            <div className='contacts_lastpage-additional-text txt-padd'>
                                <ul>
                                    <li>
                                        <a href="/">Контакты</a>
                                    </li>
                                    <li>
                                        <a href="/">Обращения граждан</a>
                                    </li>
                                    <li>
                                        <a href="/">Единое окно</a>
                                    </li>
                                    <li>
                                        <a href="/">Прес-центр</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

            </div>
        )
    }

}

export default Contacts;
